import { render } from "./FDItem.vue?vue&type=template&id=cd94f856"
import script from "./FDItem.vue?vue&type=script&lang=js"
export * from "./FDItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__